// extracted by mini-css-extract-plugin
module.exports = {"Notifications":"Notifications_Notifications__3TAbT","Container":"Notifications_Container__3yYcg","Content":"Notifications_Content__2qIee"};